export const SITE = {
    name: "Maderas La Romanilla",
    domain: "maderaslaromanilla.com",
    instagram: "@maderaslaromanilla",
    instagramUrl: "https://instagram.com/maderaslaromanilla",
    // El número real se configura en el panel admin → Configuración
    whatsapp: "",
    email: "ventas@maderaslaromanilla.com",
    slogan: "Pino nacional, herrajes y todo para el carpintero",
    // Identificación fiscal obligatoria en web y publicaciones
    razonSocial: "Maderas La Romanilla C.A.",
    rif: "J-00353907-4",
    address: "El Llanito, Venezuela — envío a todo el país · retiro en tienda",
};

export const LOGO = {
    white: "/logo-romanilla-light.png",
    black: "/logo-romanilla.png",
    color: "/logo-romanilla.png",
};

export const PAYMENT_METHODS = [
    { id: "pago_movil", label: "Pago Móvil", desc: "Bs a tasa BCV del día" },
    { id: "zelle", label: "Zelle", desc: "Pago en divisas (USD)" },
    { id: "binance", label: "Binance Pay", desc: "USDT / Cripto" },
    { id: "transferencia", label: "Transferencia", desc: "Bancaria nacional" },
    { id: "efectivo", label: "Efectivo en tienda", desc: "Retiro y pago presencial" },
];

// Los precios publicados son SIN IVA: el impuesto se suma al facturar.
export const IVA_NOTA = "+ IVA";

export const fmt = (n) =>
    new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(Number(n || 0));
